import { reportContractLogo } from './reportContractLogo'

/**
 * Ticket 13213612910: faint company logo behind each page of an UNSIGNED
 * contract. Same logo the contract header shows (ContractLogo), nothing when
 * that header shows no image. A signed contract renders exactly as it did
 * when signed (V67), so it never gets one.
 */
export const contractWatermarkSrc = ({
  homenowGray,
  listed,
  liveLogo,
  roofnowTrimmed,
  shortName,
  signed,
}: {
  homenowGray: string
  /** The company is in the customer's state list, as ContractLogo requires. */
  listed: boolean
  liveLogo: string
  /** Same trimmed ROOFNOW artwork the header prints (reportContractLogo). */
  roofnowTrimmed?: string
  shortName: string
  signed: boolean
}): string | undefined => {
  if (signed || !shortName || !listed) return undefined
  return (
    reportContractLogo(shortName, liveLogo, homenowGray, roofnowTrimmed) ||
    undefined
  )
}
